import { useEffect, useState } from "react";
import Reveal from "@/components/Reveal";
import Footer from "@/components/Footer";
import { API } from "@/lib/api";

const YEAR = 2026;

const TOLAK = [
  "JUMLAH PERMOHONAN DITOLAK KARENA PEMOHON TIDAK MEMBERIKAN DATA IDENTITAS DIRI ATAU MEMENUHI PERSYARATAN YANG DITENTUKAN OLEH LLDIKTI VII",
  "JUMLAH PERMOHONAN DITOLAK KARENA PEMOHON TIDAK MENJELASKAN TUJUAN DAN KEPENTINGAN PERMOHONANNYA",
  "JUMLAH PERMOHONAN DITOLAK KARENA INFORMASI YANG DIMINTA SEHARUSNYA TIDAK DIAJUKAN KEPADA LLDIKTI WILAYAH VII / LLDIKTI BUKAN PEMANGKU TUPOKSI YANG TERKAIT DENGAN PERMOHONAN YANG DIAJUKAN",
  "JUMLAH PERMOHONAN DITOLAK KARENA LLDIKTI TIDAK MEMILIKI DATA YANG DIMINTA",
  "JUMLAH PERMOHONAN DITOLAK KARENA INFORMASI YANG DIMINTA BELUM FINAL (MASIH DALAM PROSES / MASIH DINAMIS / BELUM LENGKAP / BELUM DIDOKUMENTASIKAN)",
  "JUMLAH PERMOHONAN DITOLAK KARENA INFORMASI YANG DIMINTA MERUPAKAN INFORMASI YANG DIKECUALIKAN UNTUK DIPUBLIKASIKAN",
];

function Row({ label, value, bold, testid }) {
  return (
    <div
      className={`flex items-center justify-between gap-6 px-5 py-4 md:px-6 ${bold ? "bg-[#EFF6FC]" : ""}`}
    >
      <p
        className={`text-[13px] leading-snug ${bold ? "font-bold text-[#0B2440]" : "text-slate-600"}`}
      >
        {label}
      </p>
      <p
        data-testid={testid}
        className={`shrink-0 font-display text-2xl font-semibold ${bold ? "text-[#1479BF]" : "text-[#0B2440]"}`}
      >
        {value}
      </p>
    </div>
  );
}

export default function DataPermohonan() {
  const [stats, setStats] = useState({
    total: 0,
    dikabulkan: 0,
    ditolak: 0,
    by_kesimpulan: {},
    rata_hari: 0,
    rata_bulan: 0,
  });

  useEffect(() => {
    fetch(`${API}/api/public/permohonan/stats?year=${YEAR}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (d) setStats({ ...stats, ...d, by_kesimpulan: d.by_kesimpulan || {} });
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tolakCount = (label) => stats.by_kesimpulan[label.replace("JUMLAH ", "")] || 0;

  const ringkasan = [
    {
      value: `${stats.rata_bulan} permohonan`,
      label:
        "rata-rata jumlah permohonan informasi yang diterima setiap bulan",
    },
    {
      value: `${stats.rata_hari} hari`,
      label: "rata-rata waktu permohonan informasi selesai dijawab",
    },
    {
      value: "0 komplain",
      label: "jumlah keberatan atas jawaban permohonan informasi",
    },
  ];

  return (
    <div className="min-h-screen bg-white text-[#0B2440] antialiased">
      <main className="px-6 pb-20 pt-28 md:px-12 md:pt-32">
        <Reveal>
          <p className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] text-[#1479BF]">
            <span
              aria-hidden="true"
              className="h-1.5 w-1.5 rounded-full bg-[#E8A33D]"
            />
            Pusat Informasi Publik — Data Permohonan
          </p>
          <h1 className="mt-6 font-display text-4xl font-semibold leading-[1.05] text-[#0B2440] md:text-6xl">
            Data Permohonan Informasi Publik Tahun {YEAR}
          </h1>
          <p className="mt-4 max-w-2xl text-[15px] text-slate-500 md:text-base">
            Pusat Informasi Publik — PPID Lembaga Layanan Pendidikan Tinggi
            Wilayah VII
          </p>
          <div className="mt-6 h-1.5 w-20 rounded-full bg-[#E8A33D]" />
        </Reveal>

        <Reveal delay={0.1}>
          <h2
            data-testid="permohonan-table-title"
            className="mt-14 font-display text-2xl font-semibold text-[#0B2440] md:text-3xl"
          >
            Data Permohonan Layanan Informasi Publik
          </h2>
          <div className="mt-6 max-w-3xl overflow-hidden rounded-3xl border border-[#E3EBF3]">
            <Row
              bold
              testid="permohonan-total"
              label="TOTAL JUMLAH PERMOHONAN"
              value={stats.total}
            />
            <div className="border-t border-[#E3EBF3]">
              <Row
                testid="permohonan-dikabulkan"
                label="JUMLAH PERMOHONAN DIKABULKAN"
                value={stats.dikabulkan}
              />
            </div>
            {TOLAK.map((t, i) => (
              <div key={t} className="border-t border-[#E3EBF3]">
                <Row testid={`permohonan-tolak-${i + 1}`} label={t} value={tolakCount(t)} />
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mx-auto mt-16 grid max-w-4xl gap-5 sm:grid-cols-3">
            {ringkasan.map((r, i) => (
              <div
                key={i}
                data-testid={`permohonan-ringkasan-${i + 1}`}
                className="rounded-3xl border border-[#E3EBF3] bg-[#F3F7FB] px-6 py-8 text-center"
              >
                <p className="font-display text-3xl font-semibold text-[#1479BF]">
                  {r.value}
                </p>
                <p className="mt-2 text-xs leading-relaxed text-slate-500">
                  {r.label}
                </p>
              </div>
            ))}
          </div>
        </Reveal>
      </main>
      <Footer compact />
    </div>
  );
}
